import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '@library-shared/base/base.component';
import { spSite_Client_By_DomainX } from '@models/StoredProcs-Extended/spSite_Client_By_DomainX';
import { SiteService } from '@services/site/site.service';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
  standalone: false,
})
export class MaintenanceComponent extends BaseComponent implements OnInit, AfterViewInit {
  siteInfo: spSite_Client_By_DomainX;

  constructor(
    private siteService: SiteService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.loadData();
  }

  loadData() {
    this.isLoading2.set(true);
    this.siteService.Site_Info().subscribe({
      next: (data) => {
        if (data.success) {
          this.siteInfo = data.record;
        }
        this.isLoading2.set(false);
      },
      error: () => {
        this.isLoading2.set(false);
      },
    });
  }

  retry() {
    this.router.navigateByUrl('/search');
  }
}
